import $ from 'jquery'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

// In the main app, Sprockets loads these before this bundle runs (globals already set).
// In Lookbook, only Vite loads, so we fill the gap here.
window.$ = window.jQuery = window.$ || $
window.toastr = window.toastr || toastr
